export const formatarCepNovo = (e) => {
    const input = e.replace(/\D/g, "");
    if (input.length <= 8) {
      const formattedCep = input.replace(/(\d{5})(\d{3})/, "$1-$2");
      return formattedCep;
    }
  };
  